"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicGroup = void 0;
const class_validator_1 = require("class-validator");
const Set_1 = require("./Set");
class PublicGroup {
    constructor(data) {
        this.id = data.id;
        this.set = data.set;
        this.categories = data.categories;
        this.name = data.name;
        this.thumb = data.thumb;
        this.order = data.order;
    }
}
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicGroup.prototype, "id", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", typeof (_a = typeof Set_1.SetId !== "undefined" && Set_1.SetId) === "function" ? _a : Object)
], PublicGroup.prototype, "set", void 0);
__decorate([
    class_validator_1.IsString({ each: true }),
    __metadata("design:type", Array)
], PublicGroup.prototype, "categories", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicGroup.prototype, "name", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], PublicGroup.prototype, "thumb", void 0);
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Number)
], PublicGroup.prototype, "order", void 0);
exports.PublicGroup = PublicGroup;
// export class Group extends NetworkModel implements IGroup {
// 	@IsString()
// 	id!: GroupId
// 	@IsString()
// 	set!: SetId
// 	@IsString({ each: true })
// 	categories: CategoryId[] = []
// 	@IsString()
// 	name!: string
// 	@IsString()
// 	thumb!: string
// 	@IsNumber()
// 	order: number = DEFAULT_ORDER
// 	@IsNumber()
// 	zIndex: number = DEFAULT_ZINDEX
// 	@IsBoolean()
// 	visible: boolean = true
// }
